import localesMap from '../../static-files/localesMap.json'

export const getAllLocalesData = () => {
  return Object.values(localesMap)
}
